import { Route, Routes } from "react-router-dom";
import { LoginScreen } from "./LoginScreen";
import { RegisterScreen } from "./RegisterScreen";
import { EmailLoginScreen } from "./EmailLoginScreen";
import { PasswordResetScreen } from "./PasswordResetScreen";
import { EmailRegisterScreen } from "./EmailRegisterScreen";

export const AuthPageRoutes = () => (
  <Routes>
    <Route path="login" element={<LoginScreen />} />
    <Route path="email-login" element={<EmailLoginScreen />} />
    <Route path="password-reset" element={<PasswordResetScreen />} />
    <Route path="register" element={<RegisterScreen />} />
    <Route path="email-register" element={<EmailRegisterScreen />} />
  </Routes>
);

export { ParentAccountAuthDialog } from "./ParentAccountAuthDialog";
export { ParentRegistrationPromptDialog } from "./ParentRegistrationPromptDialog";
